// 英语（en_GB)
import enLocale from 'element-ui/lib/locale/lang/en' // 英语
export default {
    'LANG': 'en_GB',
    ...enLocale,
    "GLOBAL": {
        'Cancel': 'Cancel',
        'Confirm': 'Confirm',
        'Exit': 'Exit',
        'Verifying': 'Verification in progress',
        'StayTuned': 'Under construction,stay tuned!',
    },
    "COMPONENTS": {
    },
    "PAGES": {
        "layout": {
            'IsActived': 'SERMI is actived, will expire at ',
            'Purchase': 'Purchase',
            'EnterYouInfo': 'enter you info',
            'Profile': 'Profile',
            'LogOut': 'log out',
            'ConfirmLogout': 'Confirm logout?',
            'SERMI': 'SERMI',
            'Consumption': 'Consumption',
            'SubscriptionConsumption': 'Subscription Consumption',
            'Productcategory': 'product category',
            'EffectTime': 'effect time',
            'ValidUntil': 'valid until',
            'CookiePolicy': 'Cookie Policy',
            'CookiePreferences': 'Cookie Preferences',
        },
        "home": {
            'MyApps': 'My application',
            'Login': 'login',
            'Register': 'register',
            'ForgotPassword': 'forgot password',
        },
    }
}